export { default } from "./AddRetailerModal";



// WEBPACK FOOTER //
// ./src/components/Retailer/AddRetailerModal/index.js